import React, { useState } from "react";
import './produto.css'
import Navbar from "../navbar/navbar";
import FooterBar from "../footer/footerBar";
import ModalProduto from "../components/modalProduto/ModalProduto";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";






function ImagemProd() {
  const [codigoProduto, setCodigoProduto] = useState("");
  const [imagem, setImagem] = useState(null);
  const [imagemPreview, setImagemPreview] = useState(null);
  const [isModalOpenImage, setIsModalOpenImage] = useState(false);
  const [descricao, setDescricao] = useState('');
  const [vendaDefault, setVendaDefault] = useState('');
  const [ncm, setNcm] = useState('');
  const [isProdutoOpen, setIsProdutoOpen] = useState(false);

  
  const handleCodigoChange = (event) => {
    setCodigoProduto(event.target.value);
  };

  
  const handleImagemChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImagem(file);
      setImagemPreview(URL.createObjectURL(file));
    }
  };

  function openModalProduto(){
    setIsProdutoOpen(true);
    
 }

 function closeModalProduto(){
      setIsProdutoOpen(false);   
   
 }

 let config = {
  headers: {
    'Authorization': localStorage.getItem("token")
  }
}

 function buscaIten(){
  api.post(vhostV1('webcash/produto/retornaproduto/'+codigoProduto), {
    loja: localStorage.getItem('loja'),
    empresa: 0         
  },config)
  .then(function (response) { 
    
   if(response && response.data && response.data.dados){
    console.log(response.data.dados);
    
    setDescricao(response.data.dados.DESCRICAO);
   
   
    
    
    // setQtdEmbalagem(response.data.dados.QTD_EMBALAGEM)
     }
   else{
     console.log("não busquei")
   }  
    
   })
  .catch(function (error) {
   
    console.log(error);
            
  });
   };

  
  const associarImagemAoProduto = () => {
    if (!codigoProduto || !imagem) {
      alert("Por favor, insira um código de produto e selecione uma imagem.");
      return;
    }
    console.log("Produto:", codigoProduto);
    console.log("Imagem associada:", imagem.name);
    alert(`Imagem associada ao produto ${codigoProduto}!`);
  };

  return (
    <div>
      <ModalProduto isOpen={isProdutoOpen}
                 onRequestClose={closeModalProduto}
                 setCodProduto={setCodigoProduto}
                 setDescricao={setDescricao}
                 setVendaDefault={setVendaDefault}
                 setNcm={setNcm}
                 titulo="Pesquisa de Produto"
                 />  
      <Navbar />
      <div className="container-fluid py-5 mt-5" style={{ minHeight: "100vh" }}>
        <div className="text-center mb-5">
          <h1 className="fw-bold">Associar Imagem ao Código do Produto</h1>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 ">
            <form>
              <div className="row">
              <div className="mb-4 col-2">
  <label htmlFor="codigo-produto" className="form-label">
    Código do Produto:
  </label>
  <div className="input-group-imagem">
    <input
      name='inputCod'
      id='codigo-produto'
      value={codigoProduto}
      onChange={(e) => setCodigoProduto(e.target.value)}
      onBlur={(e) => buscaIten(e)}
      type="text"
      className="form-control"
      
    />
    <button
      className="btn btn-primary"
      onClick={(e) => openModalProduto()}
      type="button"
      
    >
      <i style={{ fontSize: "15px" }} className="bi bi-search"></i>
    </button>
  </div>
</div>

              <div className="mb-4 col-4">
                <label htmlFor="codigo-produto" className="form-label">
                  Descrição:
                </label>
                
                <input
                  type="text"   
                  id="codigo-produto"
                  value={descricao}
                  onChange={setDescricao}
                  readOnly
                  className="form-control"
                />
                
             
              </div>

              <div className="mb-4 col-6">
                <label htmlFor="upload-imagem" className="form-label">
                  Imagem do Produto:
                </label>
                <input
                  type="file"
                  id="upload-imagem"
                  accept="image/*"
                  onChange={handleImagemChange}
                  className="form-control"
                />
              </div>
              </div>

              {imagemPreview && (
                <div className="mb-4 text-center">
                  <h5 className="mb-3">Pré-visualização da Imagem:</h5>
                  <img
                    onClick={() => setIsModalOpenImage(true)}
                    id="imagem-preview"
                    src={imagemPreview}
                    alt="Imagem do produto"
                    className="img-thumbnail shadow"
                    style={{ maxWidth: "300px", cursor: "pointer" }}
                  />
                </div>
              )}

              <button
                type="button"
                id="associar-btn"
                onClick={associarImagemAoProduto}
                className="btn btn-success w-100"
              >
                Associar Imagem ao Produto
              </button>
            </form>
          </div>
        </div>
      </div>

      {isModalOpenImage && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          onClick={() => setIsModalOpenImage(false)}
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body p-0">
                <img
                  src={imagemPreview}
                  alt="Imagem Expandida"
                  className="img-fluid"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <FooterBar />
    </div>
  );
}

export default ImagemProd;
